export { default } from './OutlinedInput';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/OutlinedInput/index.js
// module id = 95
// module chunks = 0